import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScActiveBonuses = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .bonus-cards-container {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    align-items: start;
  }

  @media (${device.mobileS}) {
    .bonus-cards-container {
      grid-template-columns: 1fr;
    }
  }
`;
